"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _icon = _interopRequireDefault(require("../../icon"));
var _Collapse = _interopRequireDefault(require("../Collapse"));
var _CollapseItem = _interopRequireDefault(require("../CollapseItem"));
var _CollapseItemTitle = _interopRequireDefault(require("../CollapseItemTitle"));
var _CollapseItemBody = _interopRequireDefault(require("../CollapseItemBody"));
var _VirtualizedList = _interopRequireDefault(require("./VirtualizedList"));
var _FilterCollapseItem = _interopRequireDefault(require("./FilterCollapseItem"));
var _FilterCollapse = _interopRequireDefault(require("./FilterCollapse.style"));
var _constants = require("./constants");
var _excluded = ["onToggle", "titleProps", "bodyProps", "multipleOpen", "classPrefix", "items", "selectedItems", "virtualized", "onChange"],
  _excluded2 = ["toggle", "openItems"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FilterCollapse = /*#__PURE__*/function (_Component) {
  _inherits(FilterCollapse, _Component);
  var _super = _createSuper(FilterCollapse);
  function FilterCollapse(props) {
    var _this;
    _classCallCheck(this, FilterCollapse);
    _this = _super.call(this, props);
    _this.elemRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      listHeight: null
    };
    return _this;
  }
  _createClass(FilterCollapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        listHeight: R.path(['current', 'offsetHeight'], this.elemRef) - _constants.OFFSET
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onToggle = _this$props.onToggle,
        titleProps = _this$props.titleProps,
        bodyProps = _this$props.bodyProps,
        multipleOpen = _this$props.multipleOpen,
        classPrefix = _this$props.classPrefix,
        items = _this$props.items,
        selectedItems = _this$props.selectedItems,
        virtualized = _this$props.virtualized,
        onChange = _this$props.onChange,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var listHeight = this.state.listHeight;
      return /*#__PURE__*/_react["default"].createElement(_FilterCollapse["default"], {
        ref: this.elemRef,
        classPrefix: classPrefix
      }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], _extends({
        classPrefix: classPrefix,
        items: items,
        multi: multipleOpen
      }, otherProps), function (_ref) {
        var toggle = _ref.toggle,
          openItems = _ref.openItems,
          other = _objectWithoutProperties(_ref, _excluded2);
        return items.map(function (item, index) {
          return /*#__PURE__*/_react["default"].createElement(_CollapseItem["default"], _extends({
            key: item.title
          }, other), /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_CollapseItemTitle["default"], _extends({
            onClick: R.compose(onToggle, function () {
              return toggle(index);
            })
          }, titleProps, other), openItems.includes(index) ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            className: "button-icon",
            size: 14,
            icon: "ion-chevron-down"
          }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            className: "button-icon",
            size: 14,
            icon: "ion-chevron-right"
          }), /*#__PURE__*/_react["default"].createElement("span", null, item.title)), openItems.includes(index) && /*#__PURE__*/_react["default"].createElement(_CollapseItemBody["default"], _extends({}, bodyProps, other), /*#__PURE__*/_react["default"].createElement("ul", null, virtualized ? /*#__PURE__*/_react["default"].createElement(_VirtualizedList["default"], {
            item: item,
            listHeight: listHeight
          }, function (_ref2) {
            var idx = _ref2.idx,
              subItem = _ref2.subItem,
              style = _ref2.style;
            return /*#__PURE__*/_react["default"].createElement(_FilterCollapseItem["default"], {
              key: "".concat(idx).concat(item.title).concat(subItem.value),
              item: item,
              subItem: subItem,
              selectedItems: selectedItems,
              virtualized: virtualized,
              onChange: onChange,
              style: style
            });
          }) : R.map(function (subItem) {
            return /*#__PURE__*/_react["default"].createElement(_FilterCollapseItem["default"], {
              key: "".concat(item.key).concat(item.title).concat(R.prop('value', subItem)),
              item: item,
              subItem: subItem,
              selectedItems: selectedItems,
              virtualized: virtualized,
              onChange: onChange
            });
          }, item.list)))));
        });
      }));
    }
  }]);
  return FilterCollapse;
}(_react.Component);
FilterCollapse.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    list: _propTypes["default"].arrayOf({})
  })).isRequired,
  selectedItems: _propTypes["default"].shape({}),
  onChange: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  multipleOpen: _propTypes["default"].bool,
  classPrefix: _propTypes["default"].string,
  titleProps: _propTypes["default"].shape({}),
  bodyProps: _propTypes["default"].shape({}),
  virtualized: _propTypes["default"].bool
};
FilterCollapse.defaultProps = {
  onChange: _utils.noop,
  onToggle: _utils.noop,
  multipleOpen: true,
  classPrefix: 'FilterCollapse',
  titleProps: {},
  bodyProps: {},
  selectedItems: {},
  virtualized: false
};
FilterCollapse.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FilterCollapse",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onToggle": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "multipleOpen": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "classPrefix": {
      "defaultValue": {
        "value": "'FilterCollapse'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "titleProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "bodyProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "selectedItems": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "virtualized": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "items": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "title": {
              "name": "string",
              "required": true
            },
            "list": {
              "name": "arrayOf",
              "value": {
                "name": "custom",
                "raw": "{}"
              },
              "required": false
            }
          }
        }
      },
      "required": true
    }
  }
};
var _default = FilterCollapse;
exports["default"] = _default;